import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';
import BrandMark from './BrandMark';

interface LayoutProps {
  children: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const navigate = useNavigate();
  const { user, logout } = useAuthStore();

  const handleLogout = () => {
    logout();
    navigate('/login', { replace: true });
  };

  return (
    <div className="app-shell-background min-h-screen">
      <header className="sticky top-0 z-50 border-b border-white/10 bg-ink/95 text-white shadow-[0_8px_40px_rgba(8,13,24,.16)] backdrop-blur-xl">
        <div className="mx-auto flex h-[68px] max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-8">
            <BrandMark inverse />
            <nav className="hidden items-center gap-1 lg:flex" aria-label="Primary navigation">
              <Link to="/" className="rounded-full bg-white/10 px-4 py-2 text-xs font-semibold text-white">
                Global search
              </Link>
              <span className="px-4 py-2 text-xs font-medium text-white/45">Pokémon only</span>
            </nav>
          </div>

          <div className="flex items-center gap-2 sm:gap-3">
            <div className="hidden text-right sm:block">
              <p className="max-w-[180px] truncate text-xs font-semibold text-white">
                {user?.user_name || user?.email || 'Collector'}
              </p>
              <p className="mt-0.5 text-[10px] uppercase tracking-[0.12em] text-white/40">Signed in</p>
            </div>
            <div className="flex h-9 w-9 items-center justify-center overflow-hidden rounded-full border border-white/15 bg-white/10 text-xs font-bold text-cyan">
              {user?.avatar_url ? (
                <img src={user.avatar_url} alt="" className="h-full w-full object-cover" />
              ) : (
                (user?.user_name || user?.email || 'C').slice(0, 1).toUpperCase()
              )}
            </div>
            <button
              onClick={handleLogout}
              className="rounded-full border border-white/15 px-3 py-2 text-xs font-semibold text-white/65 transition-colors hover:border-white/30 hover:bg-white/10 hover:text-white sm:px-4"
            >
              Sign out
            </button>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-7xl px-4 py-7 sm:px-6 sm:py-10 lg:px-8">
        {children}
      </main>
    </div>
  );
}
